export default {
  fields: {
    username: {
      label: 'CPF ou E-mail',
    },
    password: {
      label: 'Senha',
      tooltip: {
        title: 'Importante',
        text: 'A senha deve conter no mínimo 6 caracteres',
      },
      action: 'Esqueci minha senha',
      error: {
        minLenght: 'A senha deve conter no mínimo 6 caracteres',
      },
    },
  },
  heading: {
    heading1: {
      title: 'Identifique-se',
    },
    heading2: {
      title: 'Se você é novo por aqui…',
      text: 'Preencha nosso cadastro rapidinho!',
    },
  },
  forgetPassword: {
    title: 'Esqueci minha senha',
    text: 'Digite seu e-mail ou CPF cadastrado abaixo e em breve você receberá uma mensagem com sua senha.',
    cancel: 'Cancelar',
    send: 'Enviar',
    mobile: {
      success: {
        title: 'E-mail enviado com sucesso!',
        text: 'Solicitação de senha realizada com sucesso! Enviamos as informações para o <b>e-mail cadastrado.</b>',
        send: 'Ok, entendi',
      },
      error: {
        title: 'Erro ao enviar E-mail',
        text: 'Tivemos um problema ao tentar enviar o E-mail de recuperação, por favor, tente de novo mais tarde.',
        send: 'Ok, entendi',
      },
    },
    success: {
      title: 'E-mail enviado com sucesso!',
      text: 'Solicitação de senha realizada com sucesso! Enviamos as informações para o <b>e-mail cadastrado.</b>',
      send: 'Ok, entendi',
    },
    error: {
      title: 'Erro ao enviar E-mail',
      text: 'Tivemos um problema ao tentar enviar o E-mail de recuperação, por favor, tente de novo mais tarde.',
      send: 'Ok, entendi',
    },
  },
  error: 'Ops! Desculpe, mas não foi possível realizar seu login com as credenciais fornecidas.',
};
